<template>
    <div class="organization-report-notification-for-night">
        <span class="icon-info"></span>
        <span v-html="$t('OrganizationReport.data_is_updated_every_night')"></span>
    </div>
</template>

<script>
    export default {
        name: 'ReportingNotificationForNight'
    }
</script>

<style lang="scss" scoped>
    .organization-report-notification-for-night {
            margin: 0 0 10px 0;
            background: $amber;
            padding: 10px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            font-size: 1.4rem;
            line-height: 150%;

            .icon-info {
                margin: 0 10px 0 0;
                font-size: 2rem;
            }
        }
</style>